export const pricing = {
	title: "PRICING",
	fields: {
		saleType: {
			label: "Sale type",
			placeholder: "Unit",
			options: {
				unit: "Unit",
				gram: "Grams",
				liter: "Milliliters",
				variable: "Variable Price",
			},
		},
		unitOfMeasure: {
			label: "Unit of measure",
			placeholder: "Gram",
			fixedUnit: "Unit (1)",
			options: {
				gramas: "Grams",
				ml: "Milliliters",
			},
		},
		quantity: {
			label: "Quantity",
			placeholder: "100",
		},
		price: {
			label: "Price",
			placeholder: "00.00",
			tooltip: "Optional price, you can define or change it at POS",
		},
		releasePrice: {
			label: "Has release price?",
			tooltip: "Product transfer value for the hawker to sell at the event.",
			yes: "yes",
			no: "no",
			priceLabel: "Release price",
			placeholder: "00.00",
		},
		isReturnableProduct: {
			label: "Returnable product",
			tooltip:
				"Product that can be returned by the customer after purchase, within the established period and conditions.",
			yes: "yes",
			no: "no",
		},
	},
	variablePriceInfo: {
		title: "Price set at POS",
		description:
			"Variable price products have no fixed value. The price is entered at the POS at the time of sale.",
	},
};
